export const HomePageExplore = [
  {
    tag: "Free",
    courses: [
      {
        heading: "Learn HTML",
        description:
          "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Learn CSS",
        description:
          "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Responsive Web design",
        description:
          "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },
  {
    tag: "New to coding",
    courses: [
      {
        heading: "HTML",
        description:
          "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "CSS",
        description:
          "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Responsive ",
        description:
          "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },
  {
    tag: "Most popular",
    courses: [
      {
        heading: "Java",
        description:
          "Java is primarily object-oriented and features automatic memory management through garbage collection, making it relatively easy to learn and use.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Python",
        description:
          "Python's syntax is straightforward and easy to understand, resembling pseudo-code in many ways. It supports multiple programming paradigms, including procedural, object-oriented, and functional programming.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "SCSS",
        description:
          "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },
  {
    tag: "Skills paths",
    courses: [
      {
        heading: "Flask",
        description:
          "Flask is a lightweight Python micro web framework that provides the basics for web applications, including page rendering and URL routing.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Django",
        description:
          "Django is a popular choice for web development because it is powerful, flexible, and easy to use. It is used by a wide range of websites, from small personal blogs to large enterprise applications.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Fast API",
        description:
          "FastAPI is a high-performance, open-source Python web framework for building APIs with Python 3.6+ based on standard Python type hints. It is based on standards such as JSON Schema, OAuth 2.0 and OpenAPI.",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },
  {
    tag: "Career paths",
    courses: [
      {
        heading: "Next.js",
        description:
          "Next.js is an open-source web development framework created by the private company Vercel providing React-based web applications with server-side rendering and static website generation.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Nuxt.js",
        description:
          "Nuxt is a free and open source JavaScript library based on Vue.js, Nitro, and Vite. Nuxt is inspired by Next.js, which is a framework of similar purpose, based on React.js.",
        level: "Beginner",
        lessionNumber: 6,
      },
      {
        heading: "Sanity",
        description:
          "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
        level: "Beginner",
        lessionNumber: 6,
      },
    ],
  },
];
